import styled from "styled-components";
import { COLOR, FONT_SIZE } from "../themes";
import { IoMdClose } from "react-icons/io";

const Overlay = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
  z-index: 100;
  background-color: ${COLOR.grayTransparent};
`;

const Container = styled.div`
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  z-index: 101;
  width: 95%;
  max-width: 400px;
  max-height: 100%;
  padding: 1rem;
  background-color: ${COLOR.grayLight};
  border-radius: 4px;
`;

const Title = styled.h2`
  margin-bottom: 1rem;
  font-size: ${FONT_SIZE.lg};
  text-align: center;
`;

const Subtitle = styled.p`
  margin-bottom: 1rem;
  font-size: ${FONT_SIZE.sm};
  text-align: center;
`;

const CloseIcon = styled(IoMdClose)`
  position: absolute;
  top: 0;
  right: 0;
  padding: 0.5rem;
  font-size: ${FONT_SIZE.xl};
  cursor: pointer;
`;

export const Modal = ({ children, title, subtitle = '', onClose }) => {
  return (
    <Overlay onClick={onClose}>
      <Container onClick={(e) => { e.stopPropagation(); }}>
        <Title>{title}</Title>
        {subtitle && <Subtitle>{subtitle}</Subtitle>}
        <CloseIcon onClick={onClose} />
        {children}
      </Container>
    </Overlay>
  );
};
